<div class="library-list gradient">
  <app-back-button></app-back-button>
  <app-library-list-header
    [libraryList]="libraryList"
    [itemsCount]="itemsCount"
    [libraryListType]="libraryListType"
    [libraryCreatedFrom]="libraryCreatedFrom"
    (searchTermChanged)="onSearchTermChanged($event)">
  </app-library-list-header>

  <div class="library-list-container container-fluid mt-4">
    <app-bulk-select-panel
      *ngIf="itemsCount > 0"
      [items]="filteredItems"
      [bulkFeatureKey]="bulkFeatureKey">
    </app-bulk-select-panel>

    <ng-container *ngIf="filteredItems">
      <div
        *ngIf="filteredItems.length"
        class="pt-6 pb-3"
        infiniteScroll
        [fromRoot]="true"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        [infiniteScrollDisabled]="itemsLoadingState.loading || allListItemsLoaded"
        (scrolled)="loadMoreItems()">
        <div *ngFor="let item of filteredItems; trackBy: trackById; let index = index">
          <app-rollup-card
            *ngIf="item.entityType === entityTypes.FORMAT_GROUP; else agentOrConceptCard"
            [formatGroup]="item"
            [isListView]="isListView"
            [bulkFeatureKey]="bulkFeatureKey"
            [attr.id]="'library-list-item-rollup-card-' + index"
            (getIt$)="getItForRollupCard($event)"
            (placeHold$)="placeHoldOnRollupCard($event)">
          </app-rollup-card>
          <ng-template #agentOrConceptCard>
            <app-agent-or-concept-card
              [bulkFeatureKey]="bulkFeatureKey"
              [entity]="item"
              [showAuthorBio]="false">
            </app-agent-or-concept-card>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <p *ngIf="itemsLoadingState.errorCode"
       role="alert"
       aria-live="assertive"
       aria-atomic="true"
       class="m-4"
       translate
       data-automation-id="library-list-items-error-message">
      generalServerError
    </p>
    <div *ngIf="itemsLoadingState.loading" class="d-flex justify-content-center p-5">
      <div class="spinner-border text-primary library-list-items-spinner"
           role="status"
           aria-live="polite"
           data-automation-id="library-list-items-spinner">
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>
  </div>
</div>
